module.exports = __webpack_public_path__ + "img/2.f332c095.png";